import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class TowerAPI {

  static ModelNo = 53;

  static get = (id, success, failure, logout) => {
    fetch(Config.app.link + 'api/tower/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static saveTower = (tower, success, failure, logout) => {
    fetch(Config.app.link + 'api/tower/add-edit', new Header('POST', tower))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure, logout) => {
    fetch(Config.app.link + 'api/tower/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static getInnerList = (modelType, modelId, success, failure, logout) => {
    const filter = [{field: "project_id", type: "number", condition: "equals", 
      value: modelId }];
    const page = 1;
    const perPage = 10;
    fetch(Config.app.link + 'api/tower/list', new Header('POST',  { filter, page, perPage }))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static options = (success, failure, logout) => {
    fetch(Config.app.link + 'api/tower/options', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }
}

export default TowerAPI;